<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.base_setting')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>

    <div class="main-content">
      <!-- 头像设置 -->
      <div class="settings-card">
        <div class="item" >
          <div class="left">{{$t("setting.avatar")}}</div>
          <div class="right">
            <img src="/img/logo.png" class="avatar-img" />
            <van-icon name="arrow" color="#999" />
          </div>
        </div>
      </div>

      <!-- 账号信息 -->
      <div class="settings-card">
        <div class="item">
          <div class="left">{{$t('foorter.top25')}}</div>
          <div class="right">
            <span class="desc">{{userInfo.username ? userInfo.username : $t("setting.no_setting")}}</span>
            <van-icon name="arrow" color="#999" />
          </div>
        </div>
        <div class="item" @click="toSetName()">
          <div class="left">{{$t("setting.real_name")}}</div>
          <div class="right">
            <span class="desc">{{userInfo.name ? userInfo.name : $t("setting.no_setting")}}</span>
            <van-icon name="arrow" color="#999" />
          </div>
        </div>
        <div class="item" @click="toSetSex()">
          <div class="left">{{$t("setting.sex")}}</div>
          <div class="right">
            <span class="desc">{{userInfo.sex !== "0" ? userInfo.sex === "1" ? $t("setting.man") : $t("setting.female") : $t("setting.unkown")}}</span>
            <van-icon name="arrow" color="#999" />
          </div>
        </div>
      </div>

      <!-- 银行卡信息 -->
      <div class="settings-card">
        <div class="item" @click="toSetBank()">
          <div class="left">{{$t("setting.bind_bank_info")}}</div>
          <div class="right">
            <span class="desc" :class="{ 'bound': isBank }">{{isBank ? $t("setting.bindinged") : $t("setting.no")}}</span>
            <van-icon name="arrow" color="#999" />
          </div>
        </div>
      </div>
    </div>

    <!-- 头像选择弹窗 -->
    <van-popup v-model="show" position="bottom" round :style="{ height: '50%' }">
      <div class="avatarbox">
        <div class="title van-hairline--bottom">
          <van-icon @click="show=false" name="cross" />
          <div class="text">{{$t("setting.choose_avatar")}}</div>
          <div class="btnok" @click="check()">{{$t("setting.ok")}}</div>
        </div>
        <div class="content">
          <van-image
            round
            v-for="(item,index) in 185" :key="index"
            @click="select_header_img('https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png')"
            :class="{ 'choose': isActive === 'https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png'}"
            :src="'https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png'"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      show: false,
      isBank: false,
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    toSetName() {
      this.$router.push({path: '/Setname'});
    },
    toSetBank() {
      this.$router.push({path: '/Setbank'});
    },
    toSetSex() {
      this.$router.push({path: '/Setsex'});
    },
    openHerderImg() {
      this.show = true;
    },
    select_header_img(url) {
      this.isActive = url;
    },
    check() {
      this.$http({
        method: 'post',
        data: {header_img: this.isActive},
        url: 'user_header_img'
      }).then(res => {
        if (res.code === 200) {
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.isBank = true;
          } else {
            this.isBank = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
}

/* 顶部导航栏 */
.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #333;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #333;
  }
}

/* 主内容区域 */
.main-content {
  padding: 15PX;
}

/* 设置卡片组 */
.settings-card {
  background: #fff;
  border-radius: 12PX;
  padding: 0 15PX;
  margin-bottom: 15PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
}

/* 设置项 */
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18PX 0;
  border-bottom: 1PX solid #f5f5f5;
  cursor: pointer;
}

.item:last-child {
  border-bottom: none;
}

.left {
  font-size: 15PX;
  color: #333;
  font-weight: 500;
}

.right {
  display: flex;
  align-items: center;
  gap: 8PX;
}

.avatar-img {
  width: 47PX;
  height: 47PX;
  border-radius: 50%;
  object-fit: cover;
}

.desc {
  font-size: 14PX;
  color: #999;
}

.desc.bound {
  color: #07c160;
}

/* 头像选择弹窗 */
.avatarbox {
  padding: 15PX;
  color: #333;
  height: 81%;
  background-color: #fff;
}

.avatarbox .title {
  padding: 8PX 10PX 20PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16PX;
  font-weight: 600;
}

.avatarbox .title .btnok {
  color: #f53d87;
  font-size: 15PX;
  cursor: pointer;
}

.avatarbox .content {
  padding: 20PX 0 10PX;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.avatarbox .content .van-image {
  width: 70PX;
  height: 70PX;
  margin: 8PX;
  border-radius: 50%;
}

.avatarbox .content .choose {
  width: 64PX;
  height: 64PX;
  border: 4PX solid #f53d87;
}
</style>